import { Dimension1 } from '@revelio/data-access';

import { FilterId, type PrimaryFilterId } from '../types/filters';

export const getDim1 = (primaryDimension: PrimaryFilterId) => {
  switch (primaryDimension) {
    case FilterId.COMPANY:
      return Dimension1.Company;
    case FilterId.ROLE:
      return Dimension1.Role;
    case FilterId.GEOGRAPHY:
      return Dimension1.Geography;
  }
};
